import { useEffect } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import { AuthFormManagementProps } from '@/type/form.types';
import { AuthField } from '@/components/Form/Auth/AuthField';
import { AuthFieldContainer } from '@/components/Form/Auth/AuthFieldContainer';
import { Input } from '@/components/Controls/Input';
import { AuthButton } from '@/components/Custom/Button/AuthButton';
import { AuthLinkButton } from '@/components/Custom/Button/AuthLinkButton';
import { ErrorMessage } from '@/components/Message/ErrorMessage';

export const ForgotPasswordManagement = <TSchema extends FieldValues>({
  t,
  responseError,
  setResponseError,
  register,
  watch,
  errors,
  submitDisabled,
  onSubmit,
}: AuthFormManagementProps<TSchema>) => {
  const emailValue = watch && watch('email' as Path<TSchema>);

  useEffect(() => {
    if (emailValue) {
      setResponseError?.('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailValue]);

  return (
    <form onSubmit={onSubmit}>
      <div className="flex flex-col gap-5">
        <AuthFieldContainer>
          <AuthField title={t('common:email')} required>
            <Input
              {...register('email' as Path<TSchema>)}
              errorMessage={errors.email?.message as string}
              placeholder={t('common:email')}
              type="email"
              inputClassName="h-10"
            />
          </AuthField>
        </AuthFieldContainer>
      </div>
      {responseError && (
        <div className="mt-5 flex justify-center">
          <ErrorMessage message={responseError} />
        </div>
      )}
      <div className="mt-7">
        <AuthButton text={t('common:confirm')} disabled={submitDisabled} />
      </div>
      <div className="mt-5">
        <AuthLinkButton linkTo="/login" text={t('common:cancel')} />
      </div>
    </form>
  );
};
